import { Link } from "react-router-dom";

function AuthLink({ isLoggedIn, handleLogout }) {
    if (!isLoggedIn) {
        return null; // 👈 show absolutely nothing
    }

    return (
        <>
            <Link to="/admin" className="nav-link">
                Admin Page
            </Link>

            <Link
                to="#"
                onClick={handleLogout}
                className="nav-link"
            >
                Logout
            </Link>
        </>
    );
}

export default AuthLink;